(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alfheim-purchase"] && !Shopify.designMode) return;
  try {
    function alfheimEligiblePlan(candidates, cents, days) {
  if (!Array.isArray(candidates) || !Number.isInteger(cents) || !Number.isInteger(days)) return null;
  return candidates.find((candidate) => candidate && String(candidate.id || '').trim() &&
    candidate.cents === cents && candidate.days === days) || null;
}

function alfheimHeaderOfferMatches(header, current) {
  if (!header || !current || !['trial', 'serum'].includes(current.kind)) return false;
  const cents = (value) => typeof value === 'number' ? (Number.isSafeInteger(value) && value >= 0 ? value : null) : (/^\d+$/.test(String(value ?? '')) && Number.isSafeInteger(Number(value)) ? Number(value) : null);
  if (header.apKind !== current.kind || header.apCurrency !== 'USD' || current.currency !== 'USD') return false;
  if (!/^[1-9]\d*$/.test(String(header.apProductId || '')) || !/^[1-9]\d*$/.test(String(header.apVariant || ''))) return false;
  if (String(header.apProductId) !== String(current.productId) || String(header.apVariant) !== String(current.variantId)) return false;
  if (!/^\d+$/.test(String(header.apPlan || '')) || String(header.apPlan) !== String(current.planId) || String(header.apPlan) !== String(current.verifiedPlan)) return false;
  if (cents(header.apOneTimeCents) !== cents(current.oneTime) || cents(header.apFirstCents) !== cents(current.first) || cents(header.apDays) !== cents(current.days)) return false;
  if (cents(current.oneTime) === null || cents(current.first) === null || ![14, 30].includes(current.days)) return false;
  if (current.kind === 'trial') return current.days === 14 && cents(header.apRefillCents) === cents(current.refill) && cents(header.apRegularCents) === cents(current.regular) && cents(current.refill) !== null && cents(current.regular) > cents(current.refill);
  return current.days === 30 && cents(current.first) < cents(current.oneTime);
}

if (typeof document !== 'undefined') {
  (() => {
    'use strict';

    const offers = {
      '8963766354156': { kind: 'trial', first: 0, days: 14, refill: 5440, regular: 6800, todayItem: '10 ml mini', nextItem: '50 ml full-size serum', refillItem: '50 ml refill', nextCharge: 'a 50 ml serum', savings: 'Save 20% on full-size refills.' },
      '15430789431532': { kind: 'trial', first: 0, days: 14, refill: 6072, regular: 7590, todayItem: '3 trial sizes', nextItem: 'Full-size Scalp Reset Wash Trio', refillItem: 'Same full-size refill', nextCharge: 'Scalp Reset Wash Trio', savings: 'Save 20% on full-size refills.' },
      '15430790873324': { kind: 'trial', first: 0, days: 14, refill: 10392, regular: 12990, todayItem: '4 trial sizes', nextItem: 'Full-size Follicle Boost 4-Step Routine', refillItem: 'Same full-size refill', nextCharge: 'Follicle Boost 4-Step Routine', savings: 'Save 20% on full-size refills.' },
      '8963727294700': { kind: 'serum', first: 5500, days: 30, oneTime: 6800, capacity: '50 ml' },
      '9177542918380': { kind: 'kit', first: 16999, days: 30, oneTime: 18999 },
      '9177542557932': { kind: 'standard', first: 2560, days: 30, oneTime: 3200, capacity: '150 ml' },
      '9177541968108': { kind: 'standard', first: 2240, days: 30, oneTime: 2800, capacity: '316 ml' },
      '9177542197484': { kind: 'standard', first: 2240, days: 30, oneTime: 2800, capacity: '316 ml' },
      '15435640406252': { kind: 'standard', first: 3992, days: 30, oneTime: 4990, capacity: 'Full-size wash duo' },
      '15435650138348': { kind: 'standard', first: 6072, days: 30, oneTime: 7590, capacity: 'Full-size wash trio' },
      '15435659378924': { kind: 'standard', first: 7192, days: 30, oneTime: 8990, capacity: 'Full-size reset + serum duo' },
      '15435667112172': { kind: 'standard', first: 10392, days: 30, oneTime: 12990, capacity: 'Full-size 4-step routine' },
      '15435672518892': { kind: 'complete-kit', first: 18392, days: 30, oneTime: 22990, refill: 10392, regular: 12990 }
    };
    const subscriptionProductIcons = {
      "8963766354156": {
        "today": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-mini-serum-icon-20261030.png?v=1793370148&width=84",
        "refill": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-serum-icon-20261030.png?v=1793368047&width=84"
      },
      "15430789431532": {
        "today": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-trial-3-step-icon-20261030.png?v=1793370150&width=84",
        "refill": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-full-3-step-icon-20261030.png?v=1793370151&width=84"
      },
      "15430790873324": {
        "today": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-trial-4-step-icon-20261030.png?v=1793370150&width=84",
        "refill": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-full-4-step-icon-20261030.png?v=1793370151&width=84"
      },
      "8963727294700": {
        "today": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-serum-icon-20261030.png?v=1793368047&width=84",
        "refill": "https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-serum-icon-20261030.png?v=1793368047&width=84"
      }
    };
    const trialPath = '/products/saw-palmetto-scalp-reset-routine-3-step-trial-set';
    const rootSelector = '[data-alfheim-purchase]';
    const controllers = new Map();
    let sequence = 0;

    const money = (cents) => '$' + (cents / 100).toFixed(2);
    const escape = (value) => String(value).replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));

    function moneyCents(text) {
      const normalized = String(text || '').replace(/\u00a0/g, ' ').trim();
      if (/[£€¥−-]|\b(?:CAD|AUD|EUR|GBP)\b/i.test(normalized)) return null;
      const amounts = normalized.match(/[-−]?\d[\d,]*(?:\.\d{1,2})?/g);
      if (!amounts || amounts.length !== 1) return null;
      const amount = amounts[0];
      if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(amount)) return null;
      const cents = Math.round(Number(amount.replace(/,/g, '')) * 100);
      return Number.isSafeInteger(cents) ? cents : null;
    }

    function intervalDays(text) {
      const normalized = String(text || '').replace(/\s+/g, ' ').trim();
      if (/\b(?:weeks?|months?|years?)\b|[-−]\s*\d/i.test(normalized)) return null;
      const matches = Array.from(normalized.matchAll(/\b(\d+)\s+days?\b/gi));
      return matches.length === 1 ? Number(matches[0][1]) : null;
    }

    function groupPrice(group) {
      const total = group.querySelector('.sls-total-price');
      if (!total) return null;
      const copy = total.cloneNode(true);
      copy.querySelectorAll('del, s, .sls-price-below').forEach((node) => node.remove());
      return moneyCents(copy.textContent);
    }

    function serverAllocationPrice(root, form, planId) {
      if (root?.dataset.productId !== '15435672518892' || String(root.dataset.verifiedPlan || '') !== planId || !/^\d+$/.test(planId)) return null;
      const variantId = String(form?.querySelector('input[name="id"]')?.value || '');
      const raw = root.dataset.verifiedPriceCents;
      if (!/^\d+$/.test(variantId) || root.dataset.verifiedVariantId !== variantId || !/^\d+$/.test(raw || '')) return null;
      const cents = Number(raw);
      return Number.isSafeInteger(cents) ? cents : null;
    }

    function planPrice(group, root, form, planId) {
      const nativePrice = groupPrice(group);
      if (nativePrice !== null) return nativePrice;
      const total = group.querySelector('.sls-total-price');
      if (total) {
        const copy = total.cloneNode(true);
        copy.querySelectorAll('del, s, .sls-price-below').forEach((node) => node.remove());
        if (String(copy.textContent || '').trim()) return null;
      }
      return serverAllocationPrice(root, form, planId);
    }

    function nativeEnabled(input) {
      return Boolean(input && !input.disabled && !input.closest?.('.sls-disabled-option-container'));
    }

    function emptySealPlaceholder(widget) {
      return !widget || (!widget.hasAttribute('data-product') &&
        !widget.querySelector('.sls-option, [name="subs_interval"]') &&
        !String(widget.textContent || '').trim());
    }

    function nativePlans(widget, root, form) {
      if (!widget) return [];
      const plans = [];
      widget.querySelectorAll('.sls-option-container').forEach((group) => {
        const radio = group.querySelector('input.sls-option[data-type="subscription"]');
        const select = group.querySelector('select[name="subs_interval"]');
        if (!nativeEnabled(radio) || !select || select.disabled) return;
        Array.from(select.options).forEach((option) => {
          const id = String(option.value).trim();
          if (!id || option.disabled) return;
          const cents = planPrice(group, root, form, id);
          if (cents === null) return;
          plans.push({ id, cents, days: intervalDays(option.textContent), radio, select, group });
        });
      });
      return plans;
    }

    function planValue(form) {
      const fields = Array.from(form.querySelectorAll('input[name="selling_plan"]')).filter((field) => !field.disabled);
      if (!fields.length) return '';
      if (fields.length !== 1 || fields[0].type !== 'hidden') return null;
      return String(fields[0].value).trim();
    }

    function oneTimePrice(root, form, widget) {
      const raw = root.dataset.oneTimeCents;
      if (!/^\d+$/.test(raw || '')) return null;
      const price = Number(raw);
      // Seal's public DOM payload, when present, must agree for this variant.
      if (widget && widget.dataset.product) {
        try {
          const data = JSON.parse(widget.dataset.product);
          const variantId = form.querySelector('input[name="id"]')?.value;
          const variant = data.variants?.find((item) => String(item.id) === String(variantId));
          const sparseCompleteKit = Array.isArray(data.variants) && data.variants.length === 0 && serverAllocationPrice(root, form, String(root.dataset.verifiedPlan || '')) !== null;
          if (!variant && !sparseCompleteKit) return null;
          if (variant && (!Number.isInteger(variant.price) || variant.price !== price)) return null;
        } catch (_) { return null; }
      }
      return Number.isSafeInteger(price) ? price : null;
    }

    function optionRow(when, item, cents, regular, icon) {
      const image = icon ? '<img class="ap-mini-product-icon" src="' + escape(icon) + '" width="28" height="28" alt="" aria-hidden="true" decoding="async">' : '';
      return '<div class="ap-row"><span class="ap-when">' + escape(when) + image + '</span><span class="ap-item">' + escape(item) + '</span><span class="ap-amount">' + money(cents) + (regular ? '<del>' + money(regular) + '</del>' : '') + '</span></div>';
    }

    function inlineProductIcon(src) {
      return src ? '<span class="ap-icon-slot" aria-hidden="true"><img class="ap-item-icon" src="' + escape(src) + '" width="26" height="26" alt="" aria-hidden="true" decoding="async"></span>' : '';
    }

    function trialIconRow(when, item, cents, regular, src) {
      return '<div class="ap-row"><span class="ap-when">' + escape(when) + inlineProductIcon(src) + '</span><span class="ap-item">' + escape(item) + '</span><span class="ap-amount">' + money(cents) + (regular ? '<del>' + money(regular) + '</del>' : '') + '</span></div>';
    }

    function radioMarkup(controller, mode, selected) {
      return '<input type="radio" class="ap-radio" name="' + controller.choiceName + '" value="' + mode + '"' + (selected ? ' checked' : '') + '>';
    }

    function oneTimeMarkup(controller, selected) {
      const offer = controller.offer;
      const simple = offer.kind === 'one-time';
      const title = ['kit', 'complete-kit'].includes(offer.kind) ? 'One-time kit purchase' : 'One-time purchase';
      return '<label class="ap-option ap-one-time' + (selected ? ' is-selected' : '') + '">' + radioMarkup(controller, 'one-time', selected) + '<span class="ap-plan-title">' + title + (simple ? ' · ' + offer.capacity : '') + '</span><span class="ap-price">' + money(simple ? offer.first : offer.oneTime) + '</span>' + (simple ? '<div class="ap-benefits"><p>One order. No automatic renewal.</p></div>' : '') + '</label>';
    }

    function subscriptionMarkup(controller, selected) {
      const offer = controller.offer;
      const icons = subscriptionProductIcons[controller.root?.dataset?.productId];
      const start = '<label class="ap-option' + (selected ? ' is-selected' : '') + '">' + radioMarkup(controller, 'subscription', selected);
      const skip = '<p>Skip, reschedule or cancel in your account.</p>';
      if (offer.kind === 'trial') {
        const trialNotice = offer.first === 0 ? '<span class="ap-shipping">$0 TRIAL</span><span class="ap-trial-qualifier">Shipping calculated at checkout.</span>' : '<span class="ap-shipping">FREE U.S. SHIPPING</span><span class="ap-trial-qualifier">on your trial</span>';
        return start + '<span class="ap-plan-title">Trial + full-size subscription</span><div class="ap-hero"><span class="ap-price">' + money(offer.first) + ' today</span>' + trialNotice + '</div><div class="ap-schedule">' + trialIconRow('Today', offer.todayItem, offer.first, null, icons?.today) + trialIconRow('In 14 days', offer.nextItem, offer.refill, offer.regular, icons?.refill) + trialIconRow('Every 30 days after', offer.refillItem, offer.refill, null, icons?.refill) + '</div><div class="ap-benefits"><p>' + offer.savings + '</p>' + skip + '</div></label>';
      }
      if (offer.kind === 'standard') {
        return start + '<span class="ap-plan-title">Subscribe &amp; save 20%</span><div class="ap-hero"><span class="ap-price">' + money(offer.first) + '<del>' + money(offer.oneTime) + '</del></span></div><div class="ap-benefits"><p>' + escape(offer.capacity) + ' · Every 30 days</p><p>Save 20% on every delivery.</p>' + skip + '</div></label>';
      }
      if (offer.kind === 'complete-kit') {
        return start + '<span class="ap-plan-title">Complete kit + routine refill subscription</span><div class="ap-schedule">' + optionRow('Today', '1 applicator + full-size 4-step routine', offer.first, offer.oneTime) + optionRow('In 30 days', '4-step routine refill only', offer.refill, offer.regular) + '</div><p class="ap-device-note">Then ' + money(offer.refill) + ' every 30 days. The applicator ships once.</p><div class="ap-benefits"><p>Save 20% on every delivery.</p>' + skip + '</div></label>';
      }
      if (offer.kind === 'kit') {
        return start + '<span class="ap-kit-plan-head"><span class="ap-plan-title">Kit + serum refill subscription</span><span class="ap-kit-saving">SAVE $20</span></span><div class="ap-schedule">' + optionRow('Today', '1 applicator + 50 ml serum', offer.first, offer.oneTime, 'https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-kit-icon-20261030.png?v=1793368047&width=84') + optionRow('In 30 days', '50 ml serum refill only', 5500, 6800, 'https://cdn.shopify.com/s/files/1/0718/2044/3884/files/alfheim-subscription-serum-icon-20261030.png?v=1793368047&width=84') + '</div><p class="ap-device-note">Then $55 every 30 days. The applicator ships once.</p><div class="ap-benefits">' + skip + '</div></label>';
      }
      return start + '<span class="ap-plan-title">Subscribe &amp; save $13</span><div class="ap-hero"><span class="ap-price">' + money(offer.first) + '<del>' + money(offer.oneTime) + '</del></span></div><div class="ap-benefits"><p>50 ml bottle · Every 30 days' + inlineProductIcon(icons?.today) + '</p><p>Save $13 per delivery.</p>' + skip + '</div></label>';
    }

    function disclosure(offer, mode) {
      if (mode === 'one-time') return 'One order. No automatic renewal.';
      if (offer.kind === 'trial') return money(offer.first) + ' today. In 14 days, ' + money(offer.refill) + ' for ' + offer.nextCharge + '. Then ' + money(offer.refill) + ' every 30 days until canceled.';
      if (offer.kind === 'standard') return money(offer.first) + ' today, then ' + money(offer.first) + ' every 30 days until canceled.';
      if (offer.kind === 'complete-kit') return money(offer.first) + ' today. After 30 days, ' + money(offer.refill) + ' for a full-size 4-step routine refill. Then ' + money(offer.refill) + ' every 30 days until canceled.';
      if (offer.kind === 'kit') return '$169.99 today. After 30 days, $55.00 for a 50 ml serum refill. Then $55.00 every 30 days until canceled.';
      return '$55.00 today, then $55.00 every 30 days until canceled.';
    }

    class PurchaseController {
      constructor(root) {
        this.root = root;
        this.offer = offers[root.dataset.productId];
        this.host = root.closest('.product__info-container');
        this.choiceName = 'ap-choice-' + (++sequence);
        this.want = this.offer?.kind === 'one-time' ? 'one-time' : 'subscription';
        this.active = false;
        this.hasActivated = false;
        this.nativeSelectionRequested = false;
        this.nativeRecoveryUsed = false;
        this.sealSerial = 0;
        this.acceptedSerial = 0;
        this.confirmed = null;
        this.attempted = new Set();
        this.ownedNodes = [];
        this.nativeWidgets = new Set();
        this.legacyDisclosures = new Set();
        this.onChange = this.onChange.bind(this);
        this.onNativeIntent = this.onNativeIntent.bind(this);
        this.onSeal = this.onSeal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onMutations = this.onMutations.bind(this);
        this.root.addEventListener('change', this.onChange);
        this.host?.addEventListener('change', this.onChange);
        this.host?.addEventListener('input', this.onChange);
        this.host?.addEventListener('click', this.onNativeIntent, true);
        this.host?.addEventListener('keydown', this.onNativeIntent, true);
        this.host?.addEventListener('submit', this.onSubmit, true);
        document.addEventListener('sealsubs:selling_plan_changed', this.onSeal);
        this.observer = new MutationObserver(this.onMutations);
        if (this.host) this.observer.observe(this.host, { subtree: true, childList: true, characterData: true, attributes: true, attributeOldValue: true, attributeFilter: ['value', 'checked', 'selected', 'disabled', 'aria-disabled', 'aria-busy', 'hidden', 'class', 'data-product', 'data-verified-plan', 'data-verified-price-cents', 'data-verified-variant-id'] });
        this.schedule();
      }

      snapshot() {
        const form = document.getElementById(this.root.dataset.formId || '');
        if (!this.offer || !this.host || !form || form.tagName !== 'FORM' || !this.host.contains(form) || String(this.root.dataset.currency).toUpperCase() !== 'USD') return null;
        const button = form.querySelector('button[name="add"]');
        if (!button) return null;
        const widget = form.querySelector('.sealsubs-target-element');
        if (widget?.dataset.productId && widget.dataset.productId !== this.root.dataset.productId) return null;
        const price = oneTimePrice(this.root, form, widget);
        const expected = this.offer.oneTime || this.offer.first;
        if (price !== expected) return null;
        let nativeOneTime = widget?.querySelector('input.sls-option[data-type="one_time"]') || null;
        if (!nativeEnabled(nativeOneTime)) nativeOneTime = null;
        if (widget?.dataset.product) {
          try {
            if (JSON.parse(widget.dataset.product).requires_selling_plan) nativeOneTime = null;
          } catch (_) { return null; }
        }
        const verifiedId = String(this.root.dataset.verifiedPlan || '');
        const candidate = alfheimEligiblePlan(nativePlans(widget, this.root, form).filter((plan) => plan.id === verifiedId), this.offer.first, this.offer.days);
        if (this.offer.kind !== 'one-time' && !candidate) return null;
        // The widget cannot prove later product swaps or automated interval changes.
        // Only the verified deployment may attest future terms on this module root.
        // This marker never substitutes for the live price/interval/form checks.
        if (this.offer.kind !== 'one-time' && verifiedId !== candidate.id) return null;
        const plan = planValue(form);
        const plainOneTime = this.offer.kind === 'one-time' && plan === '' && emptySealPlaceholder(widget) &&
          !Array.from(form.querySelectorAll('input[name="selling_plan"]')).some((field) => String(field.value).trim());
        if (this.offer.kind === 'one-time' && widget && !nativeOneTime && !plainOneTime) return null;
        return { form, button, widget, nativeOneTime, candidate, plan, plainOneTime };
      }

      matches(snapshot, mode) {
        if (!snapshot) return false;
        if (mode === 'one-time') return snapshot.plan === '' && (snapshot.plainOneTime || Boolean(snapshot.nativeOneTime?.checked));
        const candidate = snapshot.candidate;
        return Boolean(candidate && candidate.radio.checked && candidate.select.value === candidate.id && snapshot.plan === candidate.id && planPrice(candidate.group, this.root, snapshot.form, candidate.id) === this.offer.first && intervalDays(candidate.select.selectedOptions[0]?.textContent) === this.offer.days);
      }

      schedule() {
        if (this.timer) return;
        this.timer = setTimeout(() => { this.timer = null; this.sync(); }, 30);
      }

      sync(force) {
        if (!this.root.isConnected) { this.destroy(); return; }
        const snapshot = this.snapshot();
        if (!snapshot) { this.fallback(); return; }
        this.form = snapshot.form;
        if (this.widget !== snapshot.widget) {
          this.nativeWidgets.forEach((widget) => widget.classList.remove('ap-native-widget'));
          this.widget = snapshot.widget;
          this.confirmed = null;
          this.attempted.clear();
          this.cancelPending();
        }
        const mode = this.want;
        if (mode === 'one-time' && this.offer.kind !== 'one-time' && (!this.offer.oneTime || !snapshot.nativeOneTime || snapshot.nativeOneTime.disabled)) { this.fallback(); return; }
        const key = mode + ':' + (snapshot.candidate?.id || 'none');
        const pendingReady = this.pending && this.pending.key === key && this.sealSerial > this.pending.serial;
        const alreadyConfirmed = this.confirmed === key;
        const externallyConfirmed = this.sealSerial > this.acceptedSerial;
        const plainOneTime = this.offer.kind === 'one-time' && snapshot.plainOneTime;
        // An already settled native form needs no synthetic repeat-selection event.
        // Once we request a real switch, its acknowledgement is still required.
        const initialStable = !this.hasActivated && !this.nativeSelectionRequested && !this.pending;
        if (this.matches(snapshot, mode) && (initialStable || plainOneTime || pendingReady || (!this.pending && (alreadyConfirmed || externallyConfirmed)))) {
          this.confirmed = key;
          this.acceptedSerial = this.sealSerial;
          this.cancelPending();
          this.hasActivated = true;
          this.activate(snapshot, mode);
          return;
        }
        this.fallback();
        if (!this.pending && (force || !this.attempted.has(key))) this.selectNative(snapshot, mode, key);
      }

      selectNative(snapshot, mode, key) {
        const radio = mode === 'one-time' ? snapshot.nativeOneTime : snapshot.candidate?.radio;
        if (!radio || radio.disabled) return;
        this.nativeSelectionRequested = true;
        this.attempted.add(key);
        this.pending = { key, serial: this.sealSerial };
        this.confirmed = null;
        this.pendingTimer = setTimeout(() => {
          this.pendingTimer = null;
          if (this.pending?.key === key) { this.pending = null; this.fallback(); }
        }, 3500);
        // Seal owns all selling_plan writes and the actual checkout form.
        radio.click();
        if (mode === 'subscription') {
          snapshot.candidate.select.value = snapshot.candidate.id;
          snapshot.candidate.select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.schedule();
      }

      cancelPending() {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
        this.pending = null;
      }

      onSeal(event) {
        const element = event.detail?.element;
        const form = document.getElementById(this.root.dataset.formId || '');
        if (!form) return;
        // The existing sticky cart uses this same public, form-scoped event.
        if (!element || element.nodeType !== 1 || !form.contains(element)) return;
        this.sealSerial += 1;
        this.schedule();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.schedule(), 150);
      }

      onNativeIntent(event) {
        if (!event.isTrusted) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        const target = event.target;
        if (!target || target.nodeType !== 1) return;
        const badge = target.closest('[data-ap-kit-badge]');
        if (this.offer.kind === 'kit' && badge && this.host.contains(badge)) {
          if (!this.active || !this.matches(this.snapshot(), this.want)) { this.fallback(); return; }
          event.preventDefault();
          this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.root.querySelector('.ap-radio[value="subscription"]')?.click();
          return;
        }
        const productBadge = target.closest('[data-ap-header-badge]');
        if (productBadge && this.host.contains(productBadge)) {
          const snapshot = this.snapshot();
          const header = productBadge.closest('[data-ap-product-price]');
          if (!this.active || !this.matches(snapshot, this.want) || !alfheimHeaderOfferMatches(header?.dataset, this.headerContext(snapshot))) { this.fallback(); return; }
          event.preventDefault();
          this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.root.querySelector('.ap-radio[value="subscription"]')?.click();
          return;
        }
        const row = target.closest('.sealsubs-target-element .sls-option-container');
        const radio = row?.querySelector('input.sls-option');
        const form = document.getElementById(this.root.dataset.formId || '');
        if (!form?.contains(radio) || !nativeEnabled(radio)) return;
        const mode = radio.dataset.type === 'one_time' ? 'one-time' : 'subscription';
        if (mode === this.want) return;
        this.want = mode;
        this.nativeRecoveryUsed = false;
        this.cancelPending();
        this.confirmed = null;
        this.attempted.clear();
        this.schedule();
      }

      onChange(event) {
        const target = event.target;
        if (!target || target.nodeType !== 1) return;
        if (target.matches('.ap-radio') && this.root.contains(target)) {
          if (event.currentTarget !== this.root) return;
          this.want = target.value;
          this.nativeRecoveryUsed = false;
          this.cancelPending();
          this.fallback();
          this.sync(true);
          return;
        }
        if (target.closest(rootSelector + ', [data-ap-owned]')) return;
        const form = document.getElementById(this.root.dataset.formId || '');
        if (!form?.contains(target)) return;
        if (target.matches('input.sls-option') && target.checked && !this.pending && this.hasActivated && !this.nativeRecoveryUsed) {
          const nativeMode = target.dataset.type === 'one_time' ? 'one-time' : 'subscription';
          if (nativeMode !== this.want) {
            this.nativeRecoveryUsed = true;
            this.attempted.clear();
          }
        }
        if (target.matches('input.sls-option, select[name="subs_interval"], input[name="selling_plan"], input[name="id"]')) this.schedule();
      }

      onSubmit(event) {
        if (!this.active || event.target !== this.form) return;
        if (!this.matches(this.snapshot(), this.want)) {
          this.fallback();
          // Show the original terms for review rather than submit under stale copy.
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }

      onMutations(records) {
        const form = document.getElementById(this.root.dataset.formId || '');
        const meaningful = records.some((record) => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (!target) return false;
          if (target === this.root && ['data-verified-plan', 'data-verified-price-cents', 'data-verified-variant-id'].includes(record.attributeName)) return true;
          if (target.closest(rootSelector + ', [data-ap-owned]')) return false;
          if (record.type === 'childList' && target.matches('.alfheim-standard-price-host')) return true;
          if (record.type === 'childList') {
            const changed = [...record.addedNodes, ...record.removedNodes].filter((node) => node.nodeType === 1);
            if (changed.some((node) => node.matches('form, .sealsubs-target-element, input[name="selling_plan"], button[name="add"]') || node.querySelector('form, .sealsubs-target-element, input[name="selling_plan"], button[name="add"]'))) return true;
          }
          if (!form?.contains(target)) return false;
          if (target.closest('.sealsubs-target-element')) {
            if (record.type === 'attributes' && record.attributeName === 'class') {
              const clean = (value) => String(value || '').replace(/\bap-native-widget\b/g, '').trim().split(/\s+/).sort().join(' ');
              if (clean(record.oldValue) === clean(target.className)) return false;
            }
            return true;
          }
          if (target.matches('input[name="selling_plan"], input[name="id"]')) return true;
          const button = target.closest('button[name="add"]');
          if (!button) return false;
          if (record.type !== 'attributes' && this.buttonSpan?.textContent === this.lastWrittenText) return false;
          return true;
        });
        if (meaningful) this.schedule();
      }

      buttonLabel(snapshot, mode) {
        if (mode === 'one-time') return 'ADD TO CART · ' + money(this.offer.oneTime || this.offer.first);
        if (this.offer.kind === 'trial') return 'START MY TRIAL · ' + money(this.offer.first);
        if (['kit', 'complete-kit'].includes(this.offer.kind)) return 'START MY KIT · ' + money(this.offer.first);
        return 'SUBSCRIBE · ' + money(this.offer.first);
      }

      updateButton(snapshot, mode) {
        const button = snapshot.button;
        const span = Array.from(button.children).find((node) => node.tagName === 'SPAN' && !node.matches('.loading__spinner, .sold-out-message'));
        if (!span) return;
        if (this.buttonSpan !== span) {
          this.restoreButton();
          this.buttonSpan = span;
          this.originalButtonText = span.textContent;
          this.customButtonText = null;
        }
        const soldOut = button.querySelector('.sold-out-message:not(.hidden):not([hidden])');
        const unavailable = button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true' || button.classList.contains('loading') || Boolean(soldOut);
        if (unavailable) return;
        if (span.textContent !== this.customButtonText) this.originalButtonText = span.textContent;
        const text = this.buttonLabel(snapshot, mode);
        this.customButtonText = text;
        this.lastWrittenText = text;
        if (span.textContent !== text) span.textContent = text;
      }

      restoreButton() {
        if (this.buttonSpan?.isConnected && this.buttonSpan.textContent === this.customButtonText) {
          this.lastWrittenText = this.originalButtonText;
          this.buttonSpan.textContent = this.originalButtonText;
        }
        this.customButtonText = null;
      }

      ownedNode(className) {
        const node = document.createElement('div');
        node.className = className;
        node.dataset.apOwned = this.choiceName;
        this.ownedNodes.push(node);
        return node;
      }

      afterButton(snapshot, mode) {
        const trust = snapshot.button.parentElement?.querySelector(':scope > [data-alfheim-purchase-trust]');
        const anchor = this.offer.kind !== 'trial' && trust ? trust : snapshot.button;
        if (!this.disclosureNode) this.disclosureNode = this.ownedNode('ap-disclosure');
        const html = '<p>' + escape(disclosure(this.offer, mode)) + '</p>' + (this.offer.kind === 'trial' && mode === 'subscription' ? '' : '<p>Shipping calculated at checkout.</p>');
        if (this.disclosureNode.innerHTML !== html) this.disclosureNode.innerHTML = html;
        if (anchor.nextElementSibling !== this.disclosureNode) anchor.after(this.disclosureNode);
        this.disclosureNode.hidden = false;
        if (this.offer.kind === 'one-time') {
          if (!this.secondaryNode) {
            this.secondaryNode = this.ownedNode('ap-secondary');
            this.secondaryNode.innerHTML = '<p class="ap-secondary-title">Try the 3-step routine.</p><a class="ap-trial-link" href="' + trialPath + '"><span>EXPLORE THE $0 TRIAL</span></a><p class="ap-terms">Shipping calculated at checkout. Trial subscription. Full terms on the trial page.</p>';
          }
          if (this.disclosureNode.nextElementSibling !== this.secondaryNode) this.disclosureNode.after(this.secondaryNode);
          this.secondaryNode.hidden = false;
        }
      }

      markLegacyDisclosures() {
        if (!this.active || this.offer.kind !== 'trial') return;
        this.host.querySelectorAll('.product__text .metafield-multi_line_text_field').forEach((field) => {
          const text = String(field.textContent || '').replace(/\s+/g, ' ').trim();
          const block = field.closest('.product__text');
          if (block && /^Today:\s*\$/.test(text) && /\bRenews every \d+ days at \$/.test(text) && /\buntil canceled\b/.test(text)) {
            block.classList.add('ap-legacy-disclosure');
            this.legacyDisclosures.add(block);
          }
        });
      }

      headerContext(snapshot) {
        return { kind: this.offer.kind, currency: this.root.dataset.currency, productId: this.root.dataset.productId, variantId: snapshot?.form.querySelector('input[name="id"]')?.value, planId: snapshot?.candidate?.id, verifiedPlan: this.root.dataset.verifiedPlan, oneTime: this.offer.oneTime ?? this.offer.first, first: this.offer.first, days: this.offer.days, refill: this.offer.refill, regular: this.offer.regular };
      }

      updateHeader(snapshot) {
        if (!['trial', 'serum'].includes(this.offer.kind)) return;
        const current = this.headerContext(snapshot);
        this.host?.querySelectorAll('[data-ap-product-price]').forEach((header) => {
          const valid = alfheimHeaderOfferMatches(header.dataset, current);
          header.querySelectorAll('[data-ap-header-badge], [data-ap-header-caption]').forEach((node) => { node.hidden = !valid; });
        });
      }

      hideHeaderOffer() {
        if (!['trial', 'serum'].includes(this.offer.kind)) return;
        this.host?.querySelectorAll('[data-ap-product-price] [data-ap-header-badge], [data-ap-product-price] [data-ap-header-caption]').forEach((node) => { node.hidden = true; });
      }

      activate(snapshot, mode) {
        const showOneTime = Boolean(this.offer.oneTime && snapshot.nativeOneTime && !snapshot.nativeOneTime.disabled);
        const key = mode + ':' + (snapshot.candidate?.id || 'none') + ':' + showOneTime;
        if (this.renderKey !== key) {
          let html = '<div class="ap-options">';
          if (this.offer.kind === 'one-time') html += oneTimeMarkup(this, true);
          else {
            html += subscriptionMarkup(this, mode === 'subscription');
            if (showOneTime) html += oneTimeMarkup(this, mode === 'one-time');
          }
          this.root.innerHTML = html + '</div>';
          this.root.setAttribute('role', 'group');
          this.root.setAttribute('aria-label', 'Purchase options');
          this.renderKey = key;
        }
        this.root.querySelectorAll('.ap-radio').forEach((radio) => {
          radio.checked = radio.value === mode;
          radio.closest('.ap-option')?.classList.toggle('is-selected', radio.checked);
        });
        if (snapshot.widget) {
          snapshot.widget.classList.add('ap-native-widget');
          this.nativeWidgets.add(snapshot.widget);
        }
        this.root.hidden = false;
        this.root.dataset.apState = mode;
        this.host.classList.add('alfheim-purchase-info');
        if (this.offer.kind === 'kit') {
          let headerReady = false;
          this.host.querySelectorAll('[data-ap-kit-price-block]').forEach((node) => {
            const valid = node.dataset.apKitVariant === snapshot.form.querySelector('input[name="id"]')?.value &&
              node.dataset.apKitPlan === snapshot.candidate?.id &&
              Number(node.dataset.apKitOneTimeCents) === this.offer.oneTime &&
              Number(node.dataset.apKitSubscriptionCents) === this.offer.first;
            node.hidden = !valid;
            if (valid) headerReady = true;
          });
          this.host.classList.toggle('ap-kit-header-ready', headerReady);
        }
        this.active = true;
        this.updateHeader(snapshot);
        this.markLegacyDisclosures();
        this.updateButton(snapshot, mode);
        this.afterButton(snapshot, mode);
      }

      fallback() {
        this.hideHeaderOffer();
        if (this.offer.kind === 'kit') {
          this.host?.querySelectorAll('[data-ap-kit-price-block]').forEach((node) => { node.hidden = true; });
          this.host?.classList.remove('ap-kit-header-ready');
        }
        this.active = false;
        this.root.hidden = true;
        this.root.dataset.apState = 'native';
        this.nativeWidgets.forEach((widget) => widget.classList.remove('ap-native-widget'));
        this.legacyDisclosures.forEach((block) => block.classList.remove('ap-legacy-disclosure'));
        this.legacyDisclosures.clear();
        this.ownedNodes.forEach((node) => { node.hidden = true; });
        if (this.host && !Array.from(controllers.values()).some((other) => other !== this && other.host === this.host && other.active)) this.host.classList.remove('alfheim-purchase-info');
        this.restoreButton();
      }

      destroy() {
        this.fallback();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        this.cancelPending();
        this.observer.disconnect();
        this.root.removeEventListener('change', this.onChange);
        this.host?.removeEventListener('change', this.onChange);
        this.host?.removeEventListener('input', this.onChange);
        this.host?.removeEventListener('click', this.onNativeIntent, true);
        this.host?.removeEventListener('keydown', this.onNativeIntent, true);
        this.host?.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('sealsubs:selling_plan_changed', this.onSeal);
        this.ownedNodes.forEach((node) => node.remove());
        controllers.delete(this.root);
      }
    }

    function mount(scope) {
      if (!scope?.querySelectorAll) return;
      const roots = Array.from(scope.querySelectorAll(rootSelector));
      if (scope.matches?.(rootSelector)) roots.unshift(scope);
      roots.forEach((root) => {
        if (!controllers.has(root) && offers[root.dataset.productId]) controllers.set(root, new PurchaseController(root));
      });
      controllers.forEach((controller, root) => { if (!root.isConnected) controller.destroy(); });
    }

    function start() {
      mount(document);
      const discovery = new MutationObserver((records) => {
        records.forEach((record) => {
          if (record.target.nodeType === 1 && record.target.closest(rootSelector + ', [data-ap-owned]')) return;
          record.addedNodes.forEach((node) => { if (node.nodeType === 1 && (node.matches(rootSelector) || node.querySelector(rootSelector))) mount(node); });
        });
        controllers.forEach((controller, root) => { if (!root.isConnected) controller.destroy(); });
      });
      discovery.observe(document.querySelector('main') || document.body, { subtree: true, childList: true });
      document.addEventListener('shopify:section:load', (event) => mount(event.target));
      document.addEventListener('product-info:loaded', (event) => mount(event.target));
      document.addEventListener('variant:change', (event) => {
        mount(document);
        controllers.forEach((controller) => {
          const productInfo = controller.root.closest('product-info');
          const sectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section;
          if (!event.detail?.sectionId || event.detail.sectionId === sectionId) controller.schedule();
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
}
  } catch(e) { console.error(e); }
})();

})();
